import React, { useEffect, useState } from "react";
import s from "./Message.module.scss";
import Table from "./Local Components/Table";

import { UseAuthToken } from "../../../../libs/api/userSession";
import useSWR from "swr";
import { parseClientError, swrFetcher } from "../../../../libs/api/Endpoints";
import Card from "../../../../global components/Card/Card";
import { Skeleton } from "antd";
import Unauthorised from "../../../../global components/Unauthorised";
type MessageStat = {
  totalMessages: number;
  sentMessages: number;
  scheduledMessages: number;
  pendingMessages: number;
  failedMessages: number;
};
function Message() {
  const token = UseAuthToken();
  const [filter, setFilter] = useState<
    "" | "sent" | "pending" | "failed" | "scheduled"
  >("");
  const [unauthorised, setUnauthorised] = useState<
    boolean | { title: string; message: string }
  >(false);
  const {
    data: TableContacts,
    isLoading,
    error,
  } = useSWR<{ data: MessageStat }, any, any>(
    token ? ["api/admin/messages/stats", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );

  useEffect(() => {
    if (error) {
      const e = parseClientError(error);
      if (e.statusCode === 403) {
        setUnauthorised(true);
      } else {
        setUnauthorised({
          title: "Error",
          message: e.message || "Something went wrong",
        });
      }
    }
  }, [error]);
  return (
    <div className={s.wrapper}>
      <div className={s.titles}>
        <h2 className={s.title}>Messages</h2>
        <h5 className={s.subtitle}>Keep track of all messages here</h5>
      </div>
      <div className={s.cards}>
        {unauthorised ? (
          typeof unauthorised === "boolean" ? (
            <div className={s.cardError}>
              <Unauthorised />
            </div>
          ) : (
            <div className={s.cardError}>
              <Unauthorised error={unauthorised} />
            </div>
          )
        ) : (
          <>
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("")}
                label="Total messages"
                stat={TableContacts?.data.totalMessages || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("sent")}
                label="Sent"
                stat={TableContacts?.data.sentMessages || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("scheduled")}
                label="Scheduled"
                stat={TableContacts?.data.scheduledMessages || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("failed")}
                label="Failed"
                stat={TableContacts?.data.failedMessages || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("pending")}
                label="Pending"
                stat={TableContacts?.data.pendingMessages || 0}
              />
            )}
          </>
        )}
      </div>
      <Table filters={filter} />
    </div>
  );
}

export default Message;
